/* collection-filters.js — collection filter drawer + sort/facet auto-submit.
   Vanilla, scoped, progressive enhancement. No external API, no localStorage/cookie.
   The Apply button + native form submit work without JS; this only enhances UX. */
(function () {
  "use strict";

  const section = document.querySelector("[data-collection]");
  if (!section) return; // not a collection page — do nothing

  const form = section.querySelector("[data-filters-form]");
  const drawer = section.querySelector("[data-filter-drawer]");
  const loading = section.querySelector("[data-collection-loading]");

  /* ---------- mobile filter drawer ---------- */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    const toggle = section.querySelector("[data-filter-toggle]");
    if (toggle) toggle.setAttribute("aria-expanded", "true");
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    const toggle = section.querySelector("[data-filter-toggle]");
    if (toggle) toggle.setAttribute("aria-expanded", "false");
  }

  section.addEventListener("click", function (e) {
    if (e.target.closest("[data-filter-toggle]")) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest("[data-filter-close]")) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && drawer.classList.contains("is-open"))
      closeDrawer();
  });

  /* ---------- auto-submit (sort + facets) ---------- */
  function submitForm() {
    if (!form) return;
    if (loading) {
      loading.hidden = false;
    }
    if (typeof form.requestSubmit === "function") form.requestSubmit();
    else form.submit();
  }

  if (form) {
    // Sort change -> apply (keeps current facets because they're in the same form)
    const sort = form.querySelector("[data-sort]");
    if (sort) sort.addEventListener("change", submitForm);

    // Facet change -> auto-apply (Apply button remains the no-JS path)
    form.addEventListener("change", function (e) {
      if (e.target.closest("[data-facet-input]")) submitForm();
    });
  }
})();
